/**
 * Solutions Switcher — swaps the visible content panel (and the hero
 * background image) between Retail / Lender / Enterprise on tab click,
 * entirely client-side, no page navigation.
 */
(function () {
  'use strict';

  function initSwitcher(root) {
    var tabs   = root.querySelectorAll('[data-solution-tab]');
    var panels = root.querySelectorAll('[data-solution-panel]');
    var hero   = root.querySelector('[data-solutions-hero]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-solution-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-solution-panel') === key);
        });

        var img = tab.getAttribute('data-hero-image');
        if (hero && img) hero.style.backgroundImage = "url('" + img + "')";
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.solutions-switcher').forEach(initSwitcher);
  });
})();
